import { Store } from '../../../store/player/types';
import { cancelNextRecordingCountdown } from './cancelNextRecordingCountdown';
import { showPlayAnimation } from './showPlayAnimation';
import { onPlayTick } from './onPlayTick';

/**
 * Start to play the recording.
 */
export const play = (store: Store, showAnimation = false): void => {
  const { playbackScript, playTimeoutId, setLastTickTime, setDone, setPlaying } = store.getState();

  setLastTickTime(null); // if the recording was paused we want to start with a clean slate.

  cancelNextRecordingCountdown(store);

  setPlaying(true);
  setDone(false);

  playbackScript.resume();

  if (showAnimation) {
    showPlayAnimation();
  }

  clearTimeout(playTimeoutId as number);
  onPlayTick(store);
};
